// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ulOZ2","card_header":"Card_card_header__1gHdF","title":"Card_title__IU834"};